// Angular Modules
import { Injectable } from '@angular/core';

// Third-party Libraries
import * as CryptoJS from 'crypto-js';

// Constants
import { iv, secretKey } from '../model/const/common.const';

@Injectable({ providedIn: 'root' })
export class EncryptDecryptService {
  // AES-256 key: 32 characters
  private readonly secretKey = CryptoJS.enc.Utf8.parse(secretKey);

  // AES IV: 16 characters
  private readonly iv = CryptoJS.enc.Utf8.parse(iv);

  /**
   * Encrypts a given value using AES-256-CBC
   * @param value The plain text to encrypt
   * @returns Encrypted string (Base64 encoded)
   */
  setEncrypt(value: string): string {
    const encrypted = CryptoJS.AES.encrypt(
      CryptoJS.enc.Utf8.parse(value),
      this.secretKey,
      {
        iv: this.iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      }
    );
    return encrypted.toString(); // Base64 encoded
  }

  /**
   * Decrypts an AES-256-CBC encrypted string
   * @param encryptedText The Base64 encoded encrypted string
   * @returns Decrypted plain text
   */
  getDecrypt(encryptedText: string): string {
    const decrypted = CryptoJS.AES.decrypt(encryptedText, this.secretKey, {
      iv: this.iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });

    return decrypted.toString(CryptoJS.enc.Utf8);
  }
}
